import { LucideProps } from 'lucide-react';

export const FacialHairIcon = ({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className,
  ...props
}: LucideProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M2 11.3644C2.80855 12.634 3.1285 14.0561 4.55845 14.6788C8.19047 16.2605 13.7042 12.0137 11.0722 9.05293C10.0297 7.8802 8.30955 7.46782 6.9798 8.97068C5.10954 11.0844 3.4228 14.0454 2 11.3644Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 11.3644C21.1915 12.634 20.8715 14.0561 19.4415 14.6788C15.8095 16.2605 10.2958 12.0137 12.9278 9.05293C13.9703 7.8802 15.6905 7.46782 17.0202 8.97068C18.8905 11.0844 20.5772 14.0454 22 11.3644Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
